import type { UseQueryResult } from '@tanstack/react-query';
import { useTestRubrics } from 'services/assist-api/entities/test-rubric/hooks';
import type { BaseTestRubric } from 'services/assist-api/entities/test-rubric/types';

/**
 * Fetches the rubric information for a test that is needed to display a Mark Response page.
 */
export default function useRubricForMarking(
  testInstanceTestId: number | undefined
): UseQueryResult<RequestResponse<BaseTestRubric[]>, RequestError> {
  return useTestRubrics(
    {
      filters: { tests: testInstanceTestId },
      groups: ['testrubric-mediaobjects', 'mediaobject-list'],
      include: 'mediaObjects'
    },
    { enabled: !!testInstanceTestId }
  );
}
